import * as Sentry from '@sentry/react'

const env = process.env.REACT_APP_SENTRY_ENV ?? ''
const proxy_api_url = process.env.REACT_APP_NODE_BACKEND_API ?? ''
const api_url = process.env.REACT_APP_BACKEND_API ?? ''
const ALLOWED_ENVS = ['development', 'performance', 'production']

const BLACKLIST_CATEGORIES = [
	'ui.click',
	'ui.input',
	'ui.keyDown',
	'ui.keyUp',
	'ui.blur',
	'ui.focus',
	'ui.change',
	'ui.submit',
	'ui.mouseDown',
	'ui.mouseUp',
	'ui.mouseOver',
	'ui.mouseOut',
	'ui.scroll',
	'ui.resize',
	'resource.script',
	'resource.css',
	'resource.image',
	'resource.font',
	'xhr',
	'fetch',
	'console',
]

const ALLOWED_CATEGORIES = [
	'api',
	'pageload',
	'navigation',
	'error',
	'http',
	'sentry.transaction',
]

const CONSOLE_BLACKLIST_PATTERNS = [
	'[Filtered]',
	'Information: Using HubProtocol',
	'Connected to SignalR',
	'Using HubProtocol',
]

Sentry.init({
	// dsn: 'https://d553357b3945fa8f52ab6fa4a406d6b5@o4509435466153984.ingest.us.sentry.io/4509435545780224',
	dsn: 'https://c3cfdd1de34f654e70b8925282d1d95b@o4509435466153984.ingest.us.sentry.io/4509435505803264',
	environment: env,
	enabled: ALLOWED_ENVS.includes(env),
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 1.0,
	replaysOnErrorSampleRate: 1.0,
	integrations: [
		Sentry.replayIntegration({
			block: ['iframe'],
		}),
		Sentry.browserTracingIntegration(),
	],
	tracePropagationTargets: [
		new RegExp(`^${proxy_api_url}/?`),
		new RegExp(`^${api_url}/?`),
	],
	beforeSend(event) {
		const message = event?.exception?.values?.[0]?.value ?? ''
		if (
			message.includes('Blocked a frame with origin') &&
			message.includes('cross-origin')
		) {
			return null
		}
		return event
	},
	beforeBreadcrumb(breadcrumb) {
		if (
			breadcrumb.category &&
			BLACKLIST_CATEGORIES.includes(breadcrumb.category)
		) {
			return null
		}

		if (breadcrumb.category === 'console') {
			const message = breadcrumb.message || ''
			if (
				CONSOLE_BLACKLIST_PATTERNS.some((pattern) => message.includes(pattern))
			) {
				return null
			}
		}

		if (
			breadcrumb.category &&
			!ALLOWED_CATEGORIES.includes(breadcrumb.category)
		) {
			return null
		}

		return breadcrumb
	},
})
